import { SxProps, Theme } from '@mui/material';

const sectionContainer: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2
};

const buttonContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-start',
  mt: 1
};

export const accountVisibilitySectionSx = {
  sectionContainer,
  buttonContainer
};
